export enum ShelfDeck {
	GALVANIZED_METAL = 'galvanized_metal',
	PAINTED_METAL = 'painted_metal',
	SANDED_PARTICLE_BOARD = 'sanded_particle_board',
	LAMINATED_PARTICLE_BOARD = 'laminated_particle_board',
}

export enum RackMaterial {
	ZN = 'Zinc',
	RAL_2004 = 'RAL 2004',
}

export interface Shelf {
	deck: ShelfDeck;
}

export enum EditorSide {
	FRONT = 'front',
	SIDE = 'side',
	TOP = 'top',
}

export interface Section {
	height: number;
	width: number;
	depth: number;
	selfs: Shelf[];
}
